module.exports = __webpack_public_path__ + "img/przypisz_kierowce.6fdc8b09.svg";